export const VERSION = "VERSION";
export const SESSION = "SESSION";
export const HAS_SESSION = "HAS_SESSION";
export const IS_ADMINISTRATOR = "IS_ADMINISTRATOR";